import React from 'react'
import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
// import {Provider} from 'react-redux'
// import * as _redux from './setup'
// Axios
import axios, { AxiosError, AxiosInstance } from 'axios'
import {Chart, registerables} from 'chart.js'

// Apps
import {App} from './app/App'
// import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/css/App.css'

import 'react-toastify/dist/ReactToastify.css'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
 console.log('public _URL --- ', PUBLIC_URL)

// /* const mock = */ _redux.mockAxios(axios)
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// _redux.setupAxios(axios, store)

Chart.register(...registerables)

// export function extractAPIErrorResponse(axios: AxiosInstance) {
  axios.interceptors.response.use(undefined, function (error: AxiosError) {
      (error as any).originalMessage = error.message;
      Object.defineProperty(error, "message", { get: function () {
          if (!error.response) {
              return (error as any).originalMessage;
          }
          return JSON.stringify(error.response.data);
      }});
      return Promise.reject(error);
  })
// }

ReactDOM.render(
  
  <MetronicI18nProvider>
    {/* <Provider> */}
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      {/* <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        
      </PersistGate>
    </Provider> */}
    <App basename={''} />
  </MetronicI18nProvider>
  ,
  document.getElementById('root')
)








